'use client';

import SvgSchedule from '@hc-frontend/core-icons/kit/schedule';
import { useEffect, useState } from 'react';

export type DurationProps = {
  callStartTimestamp: number;
  isActive?: boolean;
};

export default function DurationBadge({
  callStartTimestamp,
  isActive = true,
}: DurationProps) {
  const [durationSeconds, setDurationSeconds] = useState<number>(
    Math.floor(new Date().getTime() / 1000) - callStartTimestamp,
  );

  useEffect(() => {
    if (!isActive) {
      return;
    }

    const timeout = setTimeout(() => {
      setDurationSeconds(
        Math.floor(new Date().getTime() / 1000) - callStartTimestamp,
      );
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [isActive, durationSeconds, callStartTimestamp]);

  const minutes = ~~(durationSeconds / 60);
  const extraSeconds = durationSeconds % 60;

  return (
    <div
      className={`pl-[5px] pr-12-12 flex items-center rounded-full shadow-lg backdrop:bg-[rgba(0,0,0,0.05)]`}
    >
      <SvgSchedule className={`w-[18px] h-[18px]`} color={'#F5A500'} />
      <div className={`ml-8-8 w-[40px]`}>
        {minutes}:{extraSeconds.toString().padStart(2, '0')}
      </div>
    </div>
  );
}
